module.exports = __webpack_public_path__ + "static/media/Alice Yang.657b8642.png";